module.exports = __webpack_public_path__ + "static/media/three.2ecd0406.jpg";